import api from "../api";

export default class AnnouncementsApi {
  getAnnouncements() {
    return api.get("/users/announcements/");
  }
  // The Content screen ("Comunicados") calls this. It was missing entirely, so
  // every render threw "api.announcements.getContent is not a function" inside
  // the react-query fetcher instead of making a request.
  getContent(userId: string) {
    return api.get(`/users/announcements/documents/${userId}`);
  }
}
